// extracted by mini-css-extract-plugin
module.exports = {"smallTitle":"Home_smallTitle__W6Nq5"};